import Plausible from 'plausible-tracker';

// Initialize Plausible Analytics
const plausible = Plausible({
  domain: 'maip.info',
  apiHost: 'https://plausible.io', // Default Plausible Cloud
});

// Enable automatic pageview tracking
export const enableAutoPageviews = () => {
  plausible.enableAutoPageviews();
};

// Track custom events (goals)
export const trackEvent = (eventName: string, props?: Record<string, string | number>) => {
  plausible.trackEvent(eventName, { props });
};

// Pre-defined event tracking functions for better type safety
export const analytics = {
  // Track KI-Grundlagen completion
  trackModul0Completion: () => {
    trackEvent('KI-Grundlagen Abschluss');
  },

  // Track Gestaltungsrat feedback submission
  trackGestaltungsratFeedback: () => {
    trackEvent('Gestaltungsrat Feedback');
  },

  // Track Gestaltungsrat membership signup
  trackGestaltungsratSignup: () => {
    trackEvent('Gestaltungsrat Mitglied');
  },

  // Track general downloads
  trackDownload: (fileName: string) => {
    trackEvent('Download', { file: fileName });
  },

  // Track CTA clicks
  trackCTAClick: (ctaName: string) => {
    trackEvent('CTA Click', { name: ctaName });
  },

  // Track 404 errors (called automatically by NotFound component)
  track404Error: (path: string, referrer?: string) => {
    trackEvent('404 Error', { 
      path, 
      referrer: referrer || 'direct' 
    });
  },

  // Track organic search visits
  trackOrganicVisit: (searchTerm?: string) => {
    trackEvent('Organic Visit', { 
      searchTerm: searchTerm || 'unknown' 
    });
  },

  // Track page depth (engagement metric)
  trackPageDepth: (depth: number) => {
    trackEvent('Page Depth', { 
      depth: depth.toString() 
    });
  },

  // === NEUE FEATURES (Glossar 2.0, Gestaltungsrat, Ideenboard) ===

  // Glossar Events
  trackGlossarySearch: (searchTerm: string, resultsCount: number) => {
    trackEvent('Glossar Suche', { 
      term: searchTerm,
      results: resultsCount 
    });
  },

  trackGlossaryFavoriteAdded: (termId: string, termName: string) => {
    trackEvent('Glossar Favorit Hinzugefügt', { 
      termId,
      termName 
    });
  },

  trackGlossaryFavoriteRemoved: (termId: string, termName: string) => {
    trackEvent('Glossar Favorit Entfernt', { 
      termId,
      termName 
    });
  },

  trackGlossaryQuizStarted: (category?: string) => {
    trackEvent('Glossar Quiz Gestartet', { 
      category: category || 'alle' 
    });
  },

  trackGlossaryQuizCompleted: (score: number, totalQuestions: number, category?: string) => {
    trackEvent('Glossar Quiz Abgeschlossen', { 
      score: score.toString(),
      total: totalQuestions.toString(),
      percentage: Math.round((score / totalQuestions) * 100).toString(),
      category: category || 'alle'
    });
  },

  trackGlossaryCategoryFilter: (category: string) => {
    trackEvent('Glossar Kategorie Filter', { 
      category 
    });
  },

  // Ideenboard Events
  trackIdeenboardVote: (ideaId: string, ideaTitle: string) => {
    trackEvent('Ideenboard Vote', { 
      ideaId,
      ideaTitle 
    });
  },

  trackIdeenboardFilterChange: (filterType: string, filterValue: string) => {
    trackEvent('Ideenboard Filter', { 
      type: filterType,
      value: filterValue 
    });
  },

  // Gestaltungsrat Events (bereits vorhanden, aber erweitert)
  trackGestaltungsratFeedbackSubmitted: (role: string, feedbackLength: number) => {
    trackEvent('Gestaltungsrat Feedback Detail', {
      role,
      length: feedbackLength.toString()
    });
  },
};

export default plausible;
